























































import SwiperClass from 'swiper';
import { Swiper, SwiperSlide } from 'vue-awesome-swiper';
import { Component, Prop, Vue } from 'vue-property-decorator';

import { LearningPathLevel, LearningPathV2 } from 'frontend/types/learningPathV2';
import { track } from 'frontend/utils/analytics';
import LevelCard from 'frontend/views/learningPathV2/LevelCard.vue';

import Header from './Header.vue';
import CoursesModal from './CoursesModal.vue';

@Component({
  components: {
    CoursesModal,
    Header,
    LevelCard,
    Swiper,
    SwiperSlide,
  },
})
export default class Mobile extends Vue {
  $refs!: Vue['$refs'] & {
    // TODO: This is an incomplete type definition. I didn't see an obvious type
    //       export for the Swiper component, so this is a partial copy-paste.
    swiper: {
      swiperInstance: SwiperClass;
    };
  };

  @Prop({ type: Object, required: true })
  private learningPath!: LearningPathV2;

  private activeIndex: number = this.learningPath.current_level_number - 1;
  private previousIndex: number = this.activeIndex;
  private isModalOpen: boolean = false;
  // used to delay rendering swiper to prevent layout flicker
  private isReady: boolean = false;

  mounted(): void {
    this.isReady = true;
  }

  private updateActiveIndex(): void {
    // Hack to workaround a mount timing quirk in vue-awesome-swiper:
    // https://github.com/surmon-china/vue-awesome-swiper/issues/230#issuecomment-354046282
    // Can be removed if we upgrade vue-awesome-swiper or upgrade swiper to a
    // Vue 3 compatible version that contains cleaner ways to handle this.
    this.$nextTick(() => {
      this.previousIndex = this.activeIndex;
      this.activeIndex = this.$refs.swiper.swiperInstance.activeIndex;
    });
  }

  private isCurrentLevel(level: LearningPathLevel): boolean {
    return level.number === this.learningPath.current_level_number;
  }

  private isComplete(level: LearningPathLevel): boolean {
    return level.percent_complete === 100;
  }

  private isStarted(level: LearningPathLevel): boolean {
    return !this.isComplete(level) && level.percent_complete > 0;
  }

  private isPlacedOut(level: LearningPathLevel): boolean {
    return (
      !this.isStarted(level) &&
      level.number < this.learningPath.current_level_number &&
      this.learningPath.nux_placement_level_number !== null &&
      level.number < this.learningPath.nux_placement_level_number
    );
  }

  private openModal(level: LearningPathLevel): void {
    track('ui', {
      action: 'click',
      element_id: 'clicked_level',
      current_level: this.learningPath.current_level_number,
      clicked_level: level.number,
      learning_path_id: this.learningPath.id,
      learning_path_slug: this.learningPath.slug,
    });

    this.isModalOpen = true;
  }

  /**
   * This method exists to facilitate two behaviors:
   * 1. In order to retain the ability to independently click the button in the
   *    LevelCard but also optionally allow for event triggers when clicking
   *    elsewhere on the active card, the click event on the Swiper component
   *    cannot be used because there does not appear to be a way to stop
   *    propagation.
   * 2. To emulate the event lifecycle behavior of swiper's click event, we need
   *    to track previousIndex ourselves because this click event will fire
   *    after updateActiveIndex + nextTick.
   */
  private openModalOrUpdatePreviousIndex(level: LearningPathLevel, clickedCardIndex: number) {
    if (clickedCardIndex !== this.activeIndex) {
      // handles drag-clicks that don't result in a card being moved into the active position
      return;
    }

    if (this.previousIndex === this.activeIndex) {
      this.openModal(level);
    }

    this.previousIndex = this.activeIndex;
  }
}
